import React, {Component} from "react";
import ColourBox from "./ColourBox.js";
import NavBar from "./NavBar.js";
import 'rc-slider/assets/index.css';
import './Palette.css';




class Palette extends Component{
    constructor(props){
        super(props);
        this.state = ({
            level:500,
            format: 'hex',
            open: false
        });
        this.changeLevel=this.changeLevel.bind(this);
        this.changeFormat=this.changeFormat.bind(this);
        this.closePopupIcon=this.closePopupIcon.bind(this);
    }
    changeLevel(newLevel){
        this.setState({level: newLevel});
        

    }
    changeFormat(e){
       
        this.setState({format: e.target.value});
        this.setState({open:true}, () => {
            setTimeout(() => 
                this.setState({open:false}),3000);
            });
               
    }
    closePopupIcon(){
        this.setState({open:false});
        
    }
    render(){
        const {colours,paletteName, emoji} = this.props.palette;
        const {level, format, open} = this.state;
        const colourBoxes = colours[level].map(colour => {
            
            return <ColourBox id = {colour.id} background= {colour[format]} name={colour.name}/>
            
        });
        
        return(
            <div className="Palette">
                <NavBar id="NavBar" level={level} format={format} changeLevel={this.changeLevel} changeFormat={this.changeFormat} open={open} closePopupIcon={this.closePopupIcon}/>
                
                <div className="Palette-colour">
                {colourBoxes};
                
                </div>
                <footer className="Palette-footer">
                {paletteName}
                <span className="Palette-emoji">{emoji}</span>
                </footer>
            </div>
        );
    }
}

export default Palette;